import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { STICKY_CHROME_CLASS } from '@/constants/layout';

import type { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const PageHeaderBar = ({ children, rightChildren }: Props) => {
  const navigate = useNavigate();

  return (
    <div
      data-sticky-chrome
      className={`bg-white flex items-center justify-between px-2 z-20 shadow-xs border-b border-gray-200 ${STICKY_CHROME_CLASS.pageHeader}`}>
      <button className="text-gray-600" onClick={() => navigate(-1)}>
        <FontAwesomeIcon icon={faChevronLeft} size="lg" />
      </button>

      <div className="py-2 px-4 flex flex-row justify-between items-center truncate mx-auto max-w-7xl sm:px-4 lg:px-6">
        <div className="flex flex-row items-center truncate">{children}</div>
      </div>

      <div>{rightChildren}</div>

      <hr />
    </div>
  );
};
export default memo(PageHeaderBar);
